import { j as r } from "../../_virtual/jsx-runtime.js";
const i = ({
  width: s = 25,
  height: e = 3,
  viewBox: o = "0 0 25 3",
  fill: t = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: s,
    height: e,
    viewBox: o,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "line",
      {
        x1: "0.999756",
        y1: "1.52734",
        x2: "23.3838",
        y2: "1.52734",
        stroke: t,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeDasharray: "2 6"
      }
    )
  }
);
export {
  i as default
};
